import React from "react";
import { Flex, Menu, MenuButton, MenuList, IconButton } from "@chakra-ui/react";
import { IoEllipsisHorizontal } from "react-icons/io5";
import { Wrapper, Table } from "components";
import { APP_ROLES, useQueryParams, useToast } from "duck";
import { useGetUsersQuery, UserRoleEnum } from "requests";
import { Create, Delete, Edit } from "./components";
import { useAllowedUsersCount } from "./duck";

const OrganizationManagementUsers: React.FC = () => {
  const [{ pagination }] = useQueryParams();
  const { data, loading } = useGetUsersQuery({
    fetchPolicy: "cache-and-network",
    variables: { page: pagination?.page || 1, itemsPerPage: 20 }
  });

  const {
    refetch,
    allowed,
    maxCount,
    loading: countLoading
  } = useAllowedUsersCount();
  const toast = useToast();

  return (
    <>
      <Wrapper withPadding={false}>
        <Table
          loading={loading}
          data={data?.users?.collection || []}
          totalCount={data?.users?.paginationInfo?.totalCount || 0}
        >
          <Table.Column
            dataKey="name"
            label="First and Last Name"
            render={({ record: user }) => `${user.firstName} ${user.lastName}`}
          />
          <Table.Column dataKey="email" label="Email Address" />
          <Table.Column
            dataKey="userRole"
            label="Role"
            render={({ value: userRole }) => APP_ROLES[userRole]}
          />
          <Table.Column
            w="108px"
            dataKey="_id"
            label="Actions"
            render={({ value: _id, record: user }) => {
              const fullName = `${user.firstName} ${user.lastName}`;

              if (user.userRole === UserRoleEnum.RoleOrganizationAdmin) return;

              return (
                <Flex justifyContent="center">
                  <Menu strategy="fixed">
                    <MenuButton
                      display="flex"
                      color="black"
                      as={IconButton}
                      size="xs"
                      mr={0}
                      variant="unstyled"
                      icon={<IoEllipsisHorizontal style={{ marginRight: 0 }} />}
                    />

                    <MenuList>
                      <Edit _id={_id} />
                      <Delete
                        _id={_id}
                        fullName={fullName}
                        onSuccess={() => refetch()}
                      />
                    </MenuList>
                  </Menu>
                </Flex>
              );
            }}
          />
        </Table>
      </Wrapper>
      <Flex justifyContent="flex-end">
        <Create
          isDisabled={countLoading}
          onSuccess={() => refetch()}
          onClick={
            allowed
              ? undefined
              : () => {
                  toast({
                    status: "error",
                    description: `Your license allows to give access only for ${maxCount} users. Please contact Admin of the system to expand your plan.`
                  });
                }
          }
        />
      </Flex>
    </>
  );
};

export default OrganizationManagementUsers;
